import { useEffect } from "react";
import LandingNavbar from "../components/LandingNavbar";
import NumberIncrement from "../components/NumberIncrement";
import LandingHowWeWork from "../components/LandingHowWeWork";
import LandingOurLocations from "../components/LandingOurLocations";
import WhyFt from "../components/WhyFt";
import LandingTestimonial from "../components/LandingTestimonial";
import LandingNavTop from "../components/LandingNavTop";
import LandingFooter from "../components/LandingFooter";
import FaqsComponent from "../components/FaqsComponent";
import GroomingPackageComponent from "../components/GroomingPackageComponent";
import HeaderSlider from "../components/HeaderSlider";
import ExploreGroomingService from "../components/ExploreGroomingService";
import ContactFixButton from "../components/ContactFixButton";


const LandingPage = ({ location }) => {
  useEffect(() => {
    const handleHashChange = () => {
      const elementId = window.location.hash.replace("#", "");
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    };

    handleHashChange();

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return (
    <div>

      <ContactFixButton/>
      
      <div className="landing-page">
        <span id="book-now"></span>

        <div className="landing-page-navbar">
          <LandingNavTop />
          <LandingNavbar />
        </div>
        {/* <ScrollNavbar/> */}

        <HeaderSlider landingComponent={true} />

        {/* <LandingHeader location={location} /> */}

        <NumberIncrement />

        {/* <ExploreGroomingService /> */}

        {/* <LandingGroomingComponent location={location} /> */}

        <GroomingPackageComponent landingComponent={true} />

        <LandingHowWeWork location={location} />
        <WhyFt />

        <div className="landing-page-book-button">
          <a href="#grooming">Book Package Now</a>
        </div>

        <LandingOurLocations />
        <FaqsComponent />
        <LandingTestimonial />

        <LandingFooter />
      </div>
    </div>
  );
};

export default LandingPage;
